import { BlockComponentFactory } from '../BlockFactory'
import Button from 'antd/lib/button'
import { ButtonBlockProps } from './block-props.types'
import { useBlockListeners } from '../BlockHooks'
import { useBlockEngine } from '../BlockEngineContext'

export const ButtonBlockComponent = BlockComponentFactory.createBlockComponent<ButtonBlockProps>(
    props => {
        const {
            label,
            type = 'primary',
            alignment = 'left',
            size = 'medium',
            visibility = 'visible',
            disabled = false,
            style,
            loading = false,
        } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value

        const [onClickListener] = useBlockListeners<() => void | Promise<void>>('onClick')

        const containerStyle: React.CSSProperties = {
            ...style,
            display: visibility === 'hidden' ? 'none' : 'block',
            textAlign: alignment,
        }

        const buttonType = type === 'secondary' ? 'default' : 'primary'

        const buttonSize = size === 'medium' ? 'middle' : size

        return (
            <div style={containerStyle}>
                <Button
                    loading={loading}
                    danger={type === 'danger'}
                    type={buttonType}
                    size={buttonSize}
                    disabled={!isEditable || disabled}
                    onClick={() => onClickListener?.value?.()}
                >
                    {label}
                </Button>
            </div>
        )
    }
)
